import type {Globals as CssGlobals, DataType as CssTypes} from 'csstype';

import type {DeepKeyIn} from '../../../utils/utility-types';
import type {ColorsV1} from './v1';
import type {ColorsV2} from './v2';
import type {ColorsV3} from './v3';

import {colorThemeV1Factory} from './v1';
import {colorThemeV2Factory} from './v2';
import {colorThemeV3Factory} from './v3';

export type ColorThemeFactory<T extends Record<string, any>> = (
  themeId: ColorThemeID,
  options?: ColorThemeFactoryOptions,
) => T;

export type ColorThemeFactoryOptions = {
  accentColor?: ThemeAndAnyColor;
  accentForSecondaryColors?: boolean;
};

export type ColorThemeID = 'dark' | 'light';

type ColorTheme = ColorsV1 & {
  /**
   * @deprecated
   */
  v2: ColorsV2;
  v3: ColorsV3;
};

export const colorThemeFactory: ColorThemeFactory<ColorTheme> = (
  themeId,
  options,
) => {
  return {
    ...colorThemeV1Factory(themeId, options),
    v2: colorThemeV2Factory(themeId, options),
    v3: colorThemeV3Factory(themeId, options),
  };
};

export type Colors = ColorTheme;

export type CssColor =
  | 'currentcolor'
  | CssGlobals
  | CssTypes.NamedColor
  | (string & {});

export type ThemeAndAnyColor = CssColor | ThemeColor;

export type ThemeAndAnyKnownColor = CssColor | ThemeColor;

export type ThemeColor = ThemeColorV2 | ThemeColorV3;

export type ThemeColorV2 = DeepKeyIn<Colors['v2']>;

export type ThemeColorV3 = DeepKeyIn<Colors['v3']>;

/**
 * To find all usages of the deprecated colors
 * we can just remove v1 and v2 from the colors object
 * and run lint:ts
 *
 * IMPORTANT NOTE: to make getColor util throw errors
 * remove (string & {})
 */
